function slugify(text) {
  return text
    .toLowerCase()
    .replace(/<[^>]+>/g, "")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();
}

export default function parseSections(htmlContent) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  const sections = [];
  let currentSection = [];

  const elements = Array.from(doc.body.children);

  elements.forEach((element) => {
    if (element.tagName.toLowerCase() === "h2") {
      if (currentSection.length > 0) {
        const sectionContent = currentSection
          .map((el) => el.outerHTML)
          .join("");
        const sectionTitle = currentSection[0].textContent;
        sections.push({
          id: slugify(sectionTitle),
          heading: sectionTitle,
          content: sectionContent,
        });
        currentSection = [];
      }
      currentSection.push(element);
    } else if (currentSection.length > 0) {
      currentSection.push(element);
    }
  });

  if (currentSection.length > 0) {
    const sectionContent = currentSection.map((el) => el.outerHTML).join("");
    const sectionTitle = currentSection[0].textContent;
    sections.push({
      id: slugify(sectionTitle),
      heading: sectionTitle,
      content: sectionContent,
    });
  }

  return sections;
}
